export default function SidebarHeader({ logo, title, subtitle }) {
  return (
    <div className="mb-5 flex items-center gap-3 px-4 pb-2 border-b border-teal-600">
      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-white backdrop-blur-sm">
        <img src={logo} alt={title} className="h-8 w-8" />
      </div>
      <div>
        <h1 className="text-lg font-bold text-white">{title}</h1>
        <p className="text-xs text-teal-100">{subtitle}</p>
      </div>
    </div>
  );
}
